import React from 'react';
import { Box, Menu, MenuItem, Typography } from '@mui/material';
import { makeStyles } from 'tss-react/mui';
import { CreateOutlined, ExpandMore } from '@mui/icons-material';


const useEditTimeDropdownStyles = makeStyles()(theme => ({
  root: {
    display: 'flex',
    border: `1px solid ${theme.palette.primary.main}`,
    cursor: 'pointer',
    color: theme.palette.secondary.main,
    textTransform: 'uppercase',
  },
  arrow: {
    padding: '5px',
    display: 'flex',
    borderLeft: `1px solid ${theme.palette.primary.main}`,
    backgroundColor: theme.palette.secondary.background,
    color: theme.palette.secondary.main
  },
  list: {
    width: '246px',
  }
}));


export const EditTimeDropdown: React.FC<{ recurringEditMode: 'edit' | 'add'; onEditRecurring: () => void; onEditAvailability?: () => void }> = (props) => {
  const { classes } = useEditTimeDropdownStyles();
  const boxRef = React.useRef<HTMLDivElement>();
  const [ anchor, setAnchor ] = React.useState<HTMLDivElement>();

  return (
    <>
      <Menu
        classes={{ list: classes.list }}
        open={!!anchor}
        anchorEl={anchor}
        onClose={() => setAnchor(undefined)}
        anchorOrigin={{
          vertical: 'bottom',
          horizontal: 'center',
        }}
        transformOrigin={{
          vertical: 'top',
          horizontal: 'center',
        }}
      >
        <MenuItem
          onClick={() => {
            props.onEditRecurring();
            setAnchor(undefined);
          }}
        >
          {props.recurringEditMode === 'edit' ? 'Edit' : 'Set'} recurring hours
        </MenuItem>
        <MenuItem
          onClick={() => {
            props.onEditAvailability();
            setAnchor(undefined);
          }}
          disabled={!props.onEditAvailability}
        >
          Edit specific date
        </MenuItem>
      </Menu>

      <div className={classes.root} ref={boxRef} onClick={() => setAnchor(boxRef.current)}>
        <Box display="flex" flex={1} alignItems="center" justifyContent="center">
          <CreateOutlined fontSize="small" />
          <Typography variant="button" style={{ marginLeft: 10 }}>Edit Hours</Typography>
        </Box>
        <Box className={classes.arrow}>
          <ExpandMore />
        </Box>
      </div>
    </>
  );
};
